import React from 'react'
import { css } from '@emotion/css'
import { CellRenderer } from '../../../legacy-design-system/grid'
import { LoadingTextMask } from '../../../legacy-design-system/loading-masks'
import { MetadataFiltersList } from '../../session-metadata'
import { metadataCss } from '../../../legacy-design-system/text'
import { Session } from '../shared'
import { FormattedMessage } from 'react-intl'

const cellCss = css`
  padding: 8px;
  width: 100%;
`
interface GetRendererProps {
  sessionMetadataFieldID?: string
}

interface Vulnerability {
  sessions?: Session[]
}

interface SinkGroup {
  sessions?: Session[]
}

export interface RowData {
  sinkGroup?: SinkGroup
  vulnerability?: Vulnerability
}

export function getSessionMetadataCellRenderer({
  sessionMetadataFieldID
}: GetRendererProps): CellRenderer<RowData> {
  return ({ rowData, getCellContentProps }) => {
    const { vulnerability, sinkGroup } = rowData
    return renderSessionMetadataCell({
      sessionMetadataFieldID,
      rowData: vulnerability ? vulnerability : sinkGroup,
      getCellContentProps
    })
  }
}

function renderSessionMetadataCell({
  sessionMetadataFieldID,
  rowData,
  getCellContentProps
}) {
  const { sessions } = rowData
  let sessionMetadataValues: string[] = []
  if (
    !!sessionMetadataFieldID &&
    Array.isArray(sessions) &&
    sessions.length > 0
  ) {
    sessionMetadataValues = filterSessionMetadataValues(
      sessions,
      sessionMetadataFieldID
    )
  }

  return (
    <div {...getCellContentProps({ className: cellCss })}>
      {sessionMetadataValues.length > 0 ? (
        <MetadataFiltersList
          filterListStyle={metadataCss}
          filters={sessionMetadataValues}
        />
      ) : (
        <FormattedMessage
          id={'title_sessionMetadata_noneSessionMetadataFieldValue'}
        >
          {(noneValueMsg) => <div className={metadataCss}>{noneValueMsg}</div>}
        </FormattedMessage>
      )}
    </div>
  )
}

export const filterSessionMetadataValues = (
  sessions: Session[],
  selectedField: string
): string[] => {
  // prevent duplicates
  const values = new Set<string>()

  // analyze metadata fields for each session
  sessions.forEach(({ metadata }) => {
    metadata.forEach(({ agentLabel, value }) => {
      // add the field value only when the field matches the current dropdown field selection
      if (agentLabel === selectedField) {
        values.add(value)
      }
    })
  })

  return Array.from(values)
}

export function loadingSessionMetadataCellRenderer() {
  return <LoadingTextMask min={6} max={7} />
}
